import { useQuery } from "@apollo/client/react";

import NotFoundPage from "components/error/NotFoundPage";
import { useInitialSort } from "ds/components/Table/hooks/useInitialSort";
import useErrorHandle from "hooks/useErrorHandle";
import useTitle from "hooks/useTitle";
import useTypedContext from "hooks/useTypedContext";
import { AccountContext } from "views/AccountWrapper";

import IdpGroupMappingEmpty from "./Empty";
import IdpGroupMappingPageLayout from "./PageLayout";
import IdpGroupTable from "./Table";
import { INITIAL_SORT_DIRECTION, INITIAL_SORT_OPTION } from "./constants";
import { GET_MANAGED_USER_GROUPS } from "./gql";

const IdpGroupMapping = () => {
  const { accountName } = useTypedContext(AccountContext);

  // Initialize default sort parameters in URL
  useInitialSort(INITIAL_SORT_OPTION, INITIAL_SORT_DIRECTION);

  const { loading, data, error } = useQuery(GET_MANAGED_USER_GROUPS);

  useTitle(`Organization Settings · IdP group mapping · ${accountName}`);

  const ErrorContent = useErrorHandle(error);
  if (ErrorContent) {
    return ErrorContent;
  }

  if (!loading && !data?.managedUserGroups) {
    return <NotFoundPage />;
  }

  const hasGroups = !!data?.managedUserGroups?.length;
  const loadingContent = loading && !hasGroups;

  return (
    <IdpGroupMappingPageLayout hasActiveSearch={hasGroups}>
      {!loadingContent && !hasGroups && <IdpGroupMappingEmpty />}
      {(hasGroups || loadingContent) && (
        <IdpGroupTable groups={data?.managedUserGroups || []} loadingContent={loadingContent} />
      )}
    </IdpGroupMappingPageLayout>
  );
};

export default IdpGroupMapping;
